import { Utils } from "formiojs";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  AfterViewInit,
  ViewEncapsulation,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { FormioLoader, FormioCustomComponent, FormioComponent, ResourceNameService } from "dp-formio";

declare var $: any;
@Component({
  selector: "app-form-key-wrapper",
  templateUrl: "./form-key-wrapper.component.html",
  // styleUrls: ['./form-key-wrapper.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [FormioLoader],
})
export class FormKeyWrapperComponent
  implements FormioCustomComponent<any>, OnDestroy, OnChanges
{
  @ViewChild(FormioComponent) formComponent: FormioComponent;

  dir: "rtl" | "ltr";
  @Input() required: boolean;
  @Input() value: any = {};
  @Output() valueChange = new EventEmitter<any>();
  @Input() disabled: boolean;
  @Input() viewOnly: boolean;
  @Input() data: any;
  @Input() customOptions: any;
  @Input() formioComponent: any;
  private subs: Subscription[] = [];
  set sub(s: Subscription) {
    this.subs.push(s);
  }

  formKey: string;
  submissionId: string;
  submission: any = {};
  formReady = false;
  enableFormSubmit = false;

  constructor(
    private translateService: TranslateService,
    private resourceNameService: ResourceNameService,
    private formioLoader: FormioLoader
  ) {
    this.changeDirection(this.translateService.currentLang);
    this.sub = this.translateService.onLangChange.subscribe((data) => {
      this.changeDirection(data.lang);
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.customOptions) {
      if (this.customOptions.formKey) {
        this.formKey = this.customOptions.formKey;
        let extraOptions = {};
        if (this.customOptions.extra)
          extraOptions = Utils.evaluate(this.customOptions.extra, {
            data: this.data,
          });
        if (this.customOptions.submissionId)
          this.submissionId = this.customOptions.submissionId;
        if (this.customOptions.enableFormSubmit)
          this.enableFormSubmit = this.customOptions.enableFormSubmit;

        this.loadResource(extraOptions);
      }
    }
  }

  loadResource(extraOptions: any) {
    if (this.submissionId) {
      this.sub = this.resourceNameService
        .loadCustomByKeyId(this.formKey, this.submissionId)
        .subscribe((data) => {
          this.submission = data;
          this.submission.data = { ...this.submission.data, ...extraOptions };
          this.formReady = true;
        });
    } else {
      this.submission.data = { ...extraOptions };
      this.formReady = true;
    }
  }

  onChange(submission) {
    if (!this.enableFormSubmit) this.notifyValue(submission.data);
  }

  notifyValue(data) {
    this.value = data;
    this.valueChange.emit(this.value);
  }

  private changeDirection(lang) {
    this.dir = null;
    setTimeout(() => {
      this.dir = lang === "ar" ? "rtl" : "ltr";
    });
  }
  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
    this.subs = [];
  }
}
